import React from "react";
import "./CampusCss/BijrolKhedaCampus.css";

const BijrolKhedaCampus = () => {
  return (
    <div className="gurukul-containerBK">

      {/* Header Section */}
      <header className="headerBK">
        <div className="header-contentBK">
          <h1>📿 Brahmarishi Kheteshwar Ved Vigyan Gurukul</h1>
          <h2>Bijrol Kheda, District - Jalore, Rajasthan</h2>
          <div className="header-decorationBK"></div>
        </div>
      </header>

      {/* Introduction */}
      <section className="introBK">
        <div className="intro-contentBK">
          <div className="intro-textBK">
            <h2>New Beginning in Bijrol Kheda</h2>
            <p>
              Established in the academic year <strong>2018-19</strong>, this Gurukul branch serves students from <strong>2nd to 8th grade</strong> following the <strong>Rajasthan Board of Secondary Education</strong> curriculum. 
              In a short span, we've educated <strong>550+ students</strong>, combining modern education with traditional values.
            </p>
            <div className="highlight-cardBK">
              <span>🌟 Unique Feature:</span> Special focus on environmental education with practical gardening classes
            </div>
          </div>
          <img src="/home4.jpg" alt="Bijrol Kheda Gurukul" className="main-imageBK" />
        </div>
      </section>

      {/* Education System */}
      <section className="educationBK">
        <div className="section-headerBK">
          <h2>📚 Our Educational Approach</h2>
          <p className="section-subtitleBK">Balancing academics with character building</p>
        </div>
        <div className="timelineBK">
          <div className="timeline-itemBK">
            <div className="timeline-yearBK">2018</div>
            <div className="timeline-contentBK">
              <h3>Foundation Year</h3>
              <p>Started with 54 students in temporary infrastructure</p>
            </div>
          </div>
          <div className="timeline-itemBK">
            <div className="timeline-yearBK">2019 - 2023</div>
            <div className="timeline-contentBK">
              <h3>Exponentialy Increasing</h3>
              <p>Number of students increaing Exponentialy</p>
            </div>
          </div>
          <div className="timeline-itemBK">
            <div className="timeline-yearBK">2023</div>
            <div className="timeline-contentBK">
              <h3>Smart Classes Introduced</h3>
              <p>Digital learning implemented across all grades</p>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="statsBK">
        <div className="stats-gridBK">
          <div className="stat-boxBK">
            <div className="stat-numberBK">550+</div>
            <div className="stat-labelBK">Students Educated</div>
          </div>
          <div className="stat-boxBK">
            <div className="stat-numberBK">7</div>
            <div className="stat-labelBK">Grade Levels</div>
          </div>
          <div className="stat-boxBK">
            <div className="stat-numberBK">100%</div>
            <div className="stat-labelBK">RBSE Affiliation</div>
          </div>
          <div className="stat-boxBK">
            <div className="stat-numberBK">15:1</div>
            <div className="stat-labelBK">Student-Teacher Ratio</div>
          </div>
        </div>
      </section>

      {/* Footer */}
 
    </div>
  );
};

export default BijrolKhedaCampus;